import axios from 'axios';

import { store } from '@/store';

const { VITE_WORKER_URL } = import.meta.env;
const WORKER_CUSTOMER_JWT_HEADER = 'X-BigCommerce-Current-Customer-JWT';

export const workerAxios = axios.create();

workerAxios.interceptors.request.use((config) => {
  if (VITE_WORKER_URL && config.url?.startsWith(VITE_WORKER_URL)) {
    const { currentCustomerJWT } = store.getState().company.tokens;

    if (currentCustomerJWT) {
      if (config.headers) {
        config.headers.set(WORKER_CUSTOMER_JWT_HEADER, currentCustomerJWT);
      }
    }
  }

  return config;
});
